module.exports = __webpack_public_path__ + "static/img/2.4ac53381.png";